module.exports = __webpack_public_path__ + "img/corner-mask.c9a03011.png";